var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { style: { width: "100%" } }, [
    _c("div", {
      class: _vm.getClassName,
      attrs: { id: `custom-froala-${_vm.elementId}-${_vm.id}` },
      domProps: { innerHTML: _vm._s(_vm.getEditorContent) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }